import React, { useContext } from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import MemoTable from './components/MemoTable'
import LoginContext from './context'

const Memo = () => {
    const { isAuthenticated } = useContext(LoginContext)

    return (
        <>
            <section className='memo-section'>
                <CommonBox heading=" 내쪽지함 " englishHeading=" message box" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                    <MemoTable/>
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>

        </>
    )
}

export default Memo